module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idWinPanel",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "100%",
      "height": "100%",
      "border": "0px solid red",
      "display": "none"
    },
    attrs: {
      "id": "idWinPanel"
    }
  }, [_c('div', {
    ref: "idPopWinPanel",
    attrs: {
      "id": "idPopWinPanel"
    }
  }, [_c('div', {
    ref: "idWinCaptPanel",
    style: ({
      'height': _vm.ctrl.captHeight + 'px'
    }),
    attrs: {
      "id": "idWinCaptPanel"
    }
  }, [_c('div', {
    ref: "idWinCapt",
    staticClass: "DIVNoSelect",
    style: ({
      'height': _vm.ctrl.captHeight + 'px',
      'line-height': _vm.ctrl.captHeight + 'px'
    }),
    attrs: {
      "id": "idWinCapt"
    }
  }, [_vm._v(_vm._s(_vm.ctrl.captCont))]), _vm._v(" "), _c('div', {
    ref: "idWinClose",
    attrs: {
      "id": "idWinClose"
    },
    on: {
      "click": _vm.onPopWinClose
    }
  }, [_vm._v("╳")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "height": "5px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1 0 auto",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "5px"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idWinBody",
    staticStyle: {
      "flex": "1 0 auto",
      "border": "0px solid blue"
    },
    attrs: {
      "id": "idWinBody"
    }
  }, [(_vm.showWin) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "width": "5px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 auto",
      "height": "5px"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-061a4c21","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/cf/popwin.vue
// module id = 761
// module chunks = 1